<template>
    <section>
    <Header v-if="!isPhoneSize()" />
       <!-- section for contain full page   -->
       <section class="w-full h-full p-4 rtl relative" :class="isPhoneSize() ? 'mt-10 ' : 'mt-36 '"   >
      <!-- sectain to contain page width    -->
      <section v-if="isPhoneSize()" class="bg-sky-950 shadow shadow-sm  h-10 fixed top-0 inset-x-0 z-50 px-4 flex items-center justify-between">
        <div>
          <span
            @click="goBack"
            class="public-text-b text-white hover:text-amber-500 flex items-center cursor-pointer" >
            <FontAwesomeIcon icon="arrow-right" class="bold ml-1" style="width: 1.2rem" />
            <span>بازگشت</span>
          </span>
        </div>
      </section>

  <section class=" container-2xl-w mx-auto rtl  dark:bg-slate-600 shadow shadow-blue-400 dark:shadow-blue-400 overflow-hidden rounded-lg">
      <div class="flex flex-col items-center p-4 ">
        <div
          class="bg-slate-300 dark:bg-slate-100 flex items-center justify-center h-12 w-full rounded-tr-lg rounded-tl-lg"
         >
          <h2 class="public-text-title  text-red-700">
            راههای ارتباطی با پارسینه کالا
          </h2>
        </div>
        <p class="public-text-b text-green-600 my-4">تلفن های تماس</p>
        <a href="tel:+989199585421">
          <p class="public-text-title text-gray-500 hover:text-blue-500 transition" style="direction: ltr" >
            <FontAwesomeIcon icon="phone" class="" aria-label="تلفن همراه"/>
            {{ digitsEnToFa("+98 919 958 5421") }}
            
          </p>
        </a>
        <a href="tel:+989031690388">
          <p class="public-text-title text-gray-500 hover:text-blue-500 transition my-2" style="direction: ltr">
            <FontAwesomeIcon icon="phone" aria-label="تلفن همراه"/>
            {{ digitsEnToFa("+98 903 169 0388") }}
          </p>
        </a>

        <a href="tel:+2435260759">
          <p class="public-text-title text-gray-500 hover:text-blue-500 transition" style="direction: ltr">
            <FontAwesomeIcon icon="phone" aria-label="تلفن ثابت"/>

            {{digitsEnToFa("024 35260759") }}
          </p>
        </a>

        <p class="public-text-b text-green-600 my-4">شبکه های اجتماعی</p>
        <p class="public-text1 mb-4" style="direction: ltr">

          <a
            href="mailto:parsinekala@gmail.com"
            target="_blank"
            class="flex items-center h-6 text-gray-600 group"
            aria-label="لینک ایمیل"
          >
          <FontAwesomeIcon icon="envelope"   class="mr-2 text-gray-500  h-4 w-4" />
           <span class="text-base group-hover:text-green-500 transition-all">
            ParsineKala@gmail.com
           </span>
          </a>

          <a
            href="https://www.t.me/parsinekala"
            target="_blank"
            class="block  text-gray-600 my-2 group"
            aria-label="لینک تلگرام"
            >
            <FontAwesomeIcon icon="paper-plane" class="mr-2  text-gray-500 h-4 w-4"/>
            <span class="text-base group-hover:text-green-500 transition-all">
              t.me/ParsineKala
            </span>
        </a
          >

          <a
            href="https://www.instagram.com/parsinekala/"
            target="_blank"
            class="block text-gray-600 group  "
            aria-label="لینک اینستاگرام"
          >
        
          <FontAwesomeIcon :icon="['fab', 'instagram']" class="mr-2  text-gray-500 " style="width:1rem; height:1rem"/>
          <span class="text-base group-hover:text-green-500 transition-all">
            www.instagram.com/ParsineKala
          </span>
          </a>
        </p>
        <p class="public-text-b text-green-600 mb-2">ساعات تماس</p>
        <p class="text-gray-600 public-text" aria-label=" ساعات تماس">
          {{ digitsEnToFa('8') }}&nbsp;صبح تا&nbsp;{{ digitsEnToFa('6') }} بعد از
          ظهر
        </p>
        <p class="public-text text-sky-400  dark:text-sky-300 my-4 px-2 text-center">
          <span class="text-green-600">آدرس دفتر فروشگاه</span>
          (فروشگاه پارسینه کالا به صورت آنلاین فعالیت می کند و برای خرید حضوری و
          بازدید از کارگاه تولیدی تماس بگیرید )
        </p>
        <p class="public-text-b text-gray-600" aria-label="آدرس">
          <FontAwesomeIcon icon="home" class="ml-2" />آدرس:&nbsp;زنجان، ابهر- خیابان
          طالقانی شمالی - کوچه اتحاد سوم پلاک {{ digitsEnToFa("20") }}
        </p>
        <p class="public-text-b text-green-600 my-4" aria-label="کد پستی">
          کدپستی:&nbsp;<span class="text-gray-600" dir="ltr">{{
            digitsEnToFa("45619-54155")
          }}</span>
        </p>
      </div>
    </section>
       
  </section>
  <phoneFooter v-if="isPhoneSize()"/>
  <footerSection v-else class="mb-16 lg:mb-0"  />
</section>
</template>
<script setup>
// plugin resize
import { useRouter } from 'vue-router';
import { isPhoneSize } from '@/utils/isPhoneSize.js';
import { digitsEnToFa } from "persian-tools";
import Header from '@/components/Header/headerSection.vue'
import footerSection from '@/components/Footer/footerSection.vue';
import phoneFooter from '@/components/Footer/phoneFooter.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';





const router = useRouter();
const goBack = () => {
  router.back();
};
</script>
<style scoped lang="scss">

</style>